"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schema = exports.dataset = void 0;
const axios_1 = require("axios");
async function makeRequest(url, authToken, signal) {
    let headers = {
        Authorization: 'Bearer ' + authToken
    };
    const response = await axios_1.default.get(url, { headers });
    return response.data;
}
const dataset = {
    list: async (host, authToken, signal) => makeRequest(host + '/v2/dataset/ds', authToken, signal),
    get: async (host, authToken, dataset, signal) => makeRequest(`${host}/v2/dataset/ds/${dataset}`, authToken, signal)
};
exports.dataset = dataset;
const schema = {
    list: async (host, authToken, signal) => makeRequest(host + '/v2/dataset/schema', authToken, signal),
    get: async (host, authToken, schema, signal) => makeRequest(`${host}/v2/dataset/schema/${schema}`, authToken, signal)
};
exports.schema = schema;
